export const ebookConstants = {
  GET_EBOOKS_SUCCESS: 'GET_EBOOKS_SUCCESS',
  GET_EBOOKS_FAILURE: 'GET_EBOOKS_FAILURE',

  GET_EBOOK_DETAILS_SUCCESS: 'GET_EBOOK_DETAILS_SUCCESS',
  GET_EBOOK_DETAILS_FAILURE: 'GET_EBOOK_DETAILS_FAILURE'
};
